import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import 'bootstrap';
import '../../vendor/bootstrap-colorpicker/plugin';

export default class ColorPicker extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-color-picker-field');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.instance( $(element) );
    });
  }

  instance(container) {
    let input = container.find('input'),
        value = input.val(),
        indicator = container.find('.is-color-picker-indicator');

    input.colorpicker({
      useAlpha: true,
      autoInputFallback: false
    }).on('colorpickerInvalid', () => {
      input.addClass('is-danger');
      this.updateIndicatorColor(
        indicator,
        'transparent'
      );
    }).on('colorpickerChange', (event) => {
      input.removeClass('is-danger');
      this.updateIndicatorColor(
        indicator,
        event.color.toString()
      );
    });

    indicator.on('click', () => {
      input.colorpicker('toggle');
    });

    setTimeout(() => {
      if (input.val().length > 0) {
        this.updateIndicatorColor(
          indicator,
          input.colorpicker('getValue')
        );
      }
    }, 50);

  }

  updateIndicatorColor(indicator, color) {
    let borderColor = color;
    if (this.lightOrDark(color) === 'light') borderColor = '';
    indicator.css('border-color', borderColor);
    indicator.find('.overlay').css('background-color', color);
  }

  lightOrDark(color) {

    // Variables for red, green, blue values
    let r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      r = color[1];
      g = color[2];
      b = color[3];
    } else {

      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      color = +("0x" + color.slice(1).replace(
        color.length < 5 && /./g, '$&$&'));

      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp >= 200) {

      return 'light';
    }
    else {

      return 'dark';
    }
  }

}